// extracted by mini-css-extract-plugin
export default {"card":"SearchResultPanelContentEventCard-module__card___1ZDLF"};